import React, { useContext } from 'react';
import dayjs from 'dayjs';

import { CatalogContext } from 'src/pages/CatalogPage/CatalogPage';
import { IAuctionItem } from 'src/pages/CatalogPage/CatalogPage.i';
import { IconContainer } from 'src/pages/CatalogPage/components/AuctionItems/AuctionItem/ItemIcons/ItemIcons.style';
import { WithTooltip } from '@riac/design-system';
import { interestLevels } from 'src/lib/interestLevels';

import { LazyImg } from '@riac/design-system';

import LogoRare from 'images/logo-rare.png';
import LogoDocumentation from 'images/logo-documentation.png';
import LogoBox from 'images/logo-box.png';
import LogoAntique from 'images/logo-antique.png';
import LogoClass3 from 'images/logo-class3.png';
import LogoModern from 'images/logo-modern.png';
import LogoCR from 'images/logo-cr.png';
import LogoYoutube from 'images/logo-youtube.png';

export const ItemIcons = ({ item }: { item: IAuctionItem }) => {
  const { compactMode, auctionEndDate } = useContext(CatalogContext);

  const hideInterestLevel = dayjs().isAfter(auctionEndDate.add(1, 'day'));
  const itemInterest = item.ItemInterest > 3 ? 3 : item.ItemInterest;
  const tests = [/A/, /I/, /M/, /C/];

  if(compactMode === 'true') {
    return null;
  }
  return (
    <IconContainer>
      {/*
          item.LotItemCount > 1 &&
          <WithTooltip position='top' text={`Lot contains ${item.LotItemCount} items`} inverted>
          <LazyImg
            className="LazyImg-responsive LazyImg-fluid icon"
            src={broken('images/icon-unreadsystem.jpg'))}
            alt={`Lot contains ${item.LotItemCount} items`}
          />
          </WithTooltip>
        */}

      {/* item.RareItem && (
        <WithTooltip position='top' text='Lot contains rare items' inverted>
          <LazyImg src={LogoRare} alt='Lot contains rare items' />
        </WithTooltip>
      )*/}
      {item.HasDocs && (
        <WithTooltip position='top' text='Lot contains items with documentation' inverted>
          <LazyImg
            src={LogoDocumentation}
            alt='Lot contains items with documentation'
          />
        </WithTooltip>
      )}
      {item.HasBox && (
        <WithTooltip position='top' text='Lot contains items with box' inverted>
          <LazyImg src={LogoBox} alt='Lot contains items with box' />
        </WithTooltip>
      )}
      {tests[0].test(item.A_MCodeLot || item.A_MCode) && (
        <WithTooltip position='top' text='Lot contains antique items' inverted>
          <LazyImg src={LogoAntique} alt='Lot contains antique items' />
        </WithTooltip>
      )}
      {tests[1].test(item.A_MCodeLot || item.A_MCode) && (
        <WithTooltip position='top' text='Lot contains Class III items' inverted>
          <LazyImg src={LogoClass3} alt='Lot contains Class III items' />
        </WithTooltip>
      )}
      {tests[2].test(item.A_MCodeLot || item.A_MCode) && (
        <WithTooltip position='top' text='Lot contains Modern items' inverted>
          <LazyImg src={LogoModern} alt='Lot contains Modern items' />
        </WithTooltip>
      )}
      {tests[3].test(item.A_MCodeLot || item.A_MCode) && (
        <WithTooltip position='top' text='Lot contains Curio and Relic items' inverted>
          <LazyImg src={LogoCR} alt='Lot contains Curio and Relic items' />
        </WithTooltip>
      )}
      {item.HasVideo && (
        <WithTooltip position='top' text='Lot contains items with attached video' inverted>
          <LazyImg
            src={LogoYoutube}
            alt='Lot contains items with attached video'
          />
        </WithTooltip>
      )}
      {!hideInterestLevel && item.ItemInterest !== 0 && (
        <WithTooltip position='top' text={`Interest Level: ${interestLevels[itemInterest].description}`} inverted>
          <LazyImg
            src={interestLevels[itemInterest].imagePath}
            alt={interestLevels[itemInterest].description}
          />
        </WithTooltip>
      )}
    </IconContainer>
  );
};
